import { render, staticRenderFns } from "./movement.vue?vue&type=template&id=4b9c3052&"
import script from "./movement.vue?vue&type=script&lang=js&"
export * from "./movement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports